/* eslint-disable import/first */
import React, { useState, useEffect, useCallback } from 'react';
import format from 'date-fns/format';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { useNavigate } from '@reach/router';
import { FormattedMessage, useIntl } from 'react-intl';
import { Paper, Grid } from '@material-ui/core';
import Skeleton from 'react-loading-skeleton';
import { FaAngleDoubleDown } from '@react-icons/all-files/fa/FaAngleDoubleDown';
import DialogBox from '../../components/DialogBox';
import DrawerPwa from '../../components/DrawerPwa';

const { selectDesktop } = Slices.appSlice;
const { selectCurrentCountry } = Slices.profileSlice;
const { orderStatusConstants, selectBaseURL, selectCountryValidations } = Slices.configSlice;
const { getOrderDetail, orderStatus } = Slices.orderSlice;
import noImg from '../../assets/no-itm.png';
import Header from '../../components/Header';
const { selectStoreEntities } = Slices.storeSlice;
import { decimalChecker } from 'spwa-ui-library/esm/utils/helper';
import LanguageButton from '../../components/LanguageButton';
import { FaArrowLeft } from '@react-icons/all-files/fa/FaArrowLeft';
import css from './index.module.scss';
import Shape from './images/Shape.svg';
import BackButton from '../../components/BackButton';
import classNames from 'classnames';
import CartValues from '../Cart/CartValues';

function OrderDetail({ orderId }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const intl = useIntl();
  const [allStatus, setAllStatus] = useState('initial');
  const profile = useSelector((state) => state.profile);
  const storeList = useSelector(selectStoreEntities);
  const [selectedStore, setSelectedStore] = useState({});
  const country = useSelector(selectCurrentCountry);
  const [openViewDetailsPopup, setOpenViewDetailsPopUp] = useState(false);
  const [itemDetails, setItemDetails] = useState(null);

  const countryValidations = useSelector((state) => selectCountryValidations(state, country));

  const [orderInfo, setOrderInfo] = useState();
  const [oStatus, setInfoStatus] = useState();
  const onExitMemoized = useCallback((e) => navigate(-1), [navigate]);

  const backIcon = <FaArrowLeft onClick={onExitMemoized} />;

  useEffect(() => {
    if (allStatus === 'initial') {
      dispatch(getOrderDetail({ orderId })).then((resp) => {
        if (resp.error) {
          navigate(`/${intl.locale}/home`);
        } else {
          setOrderInfo((prev) => resp?.payload?.data?.data);
        }
      });
      dispatch(orderStatus({ orderId })).then((resp) => {
        setInfoStatus((prev) => resp?.payload?.data?.data);
        setAllStatus((prev) => 'again');
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allStatus, dispatch, orderId]);

  const vatConst = countryValidations?.constants.cartAmount.findIndex(({ name }) => name === 'TAX');
  const isDesktop = useSelector(selectDesktop);

  useEffect(() => {
    Object.values(storeList || {}).every((val) => {
      if (val.storeId === orderInfo?.store?.storeId) {
        setSelectedStore(val);
        return false;
      }
      return true;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderInfo]);
  const storeNameTitle = `name_${intl.locale}`;
  const addressString = `address_${intl.locale}`;
  useEffect(() => {
    if (
      orderInfo?.country &&
      profile.status === 'succeeded' &&
      profile.country !== orderInfo?.country
    ) {
      navigate(`/${intl.locale}/home`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderInfo, profile?.country, profile?.status]);
  if (!orderInfo) {
    return (
      <div className={css.root}>
        <main className={css.main}>
          <Skeleton count={1} className={css.Skeleton} height={300} />
          <Skeleton count={1} className={css.Skeleton} height={300} />
        </main>
      </div>
    );
  }

  // CARD FOR TOTAL SUB TOTAL AND TAX INFO
  const Card = () => {
    return (
      <div className={css.cardContainer}>
        <Grid className={css.id}>
          <>
            {orderInfo?.orderDisplayNumber ? (
              <h5 className={css.orbNumber}>
                <FormattedMessage id={'orderdetails_orderno'} defaultMessage="Order No" />{' '}
                <span className={css.redText}>{orderInfo?.orderDisplayNumber}</span>
              </h5>
            ) : null}
          </>
        </Grid>
        <CartValues amountObj={orderInfo?.amount} currency={countryValidations?.currency} />
        <div className={css.row}>
          <span className={css.tax}>
            {countryValidations?.constants.cartAmount[vatConst].value} {orderInfo.vat.amount}{' '}
            {countryValidations?.currency}
          </span>
        </div>
        <Grid className={`${css.id} ${css.marginTop}`}>
          <div>
            {orderInfo.status === 'PENDING' ? (
              <FormattedMessage id="pendingConfirmation" />
            ) : (
              <span>
                <FormattedMessage id="trackorder_orderno" defaultMessage="order id" />
                {`. `}
                <span className={css.boldText}>
                  {country}-{orderInfo.uOrderRef}
                </span>
              </span>
            )}
            <span>{` | `}</span>
            <span>{format(orderInfo.createdAt, 'dd MMM, yyyy')}</span>
          </div>
        </Grid>
      </div>
    );
  };
  // CARD FOR ADDRESS INFO
  const CardAddress = () => {
    return (
      <div className={css.addressContainer}>
        <div className={css.addressRow}>
          <div className={css.imageContainer}>
            <img src={Shape} alt="Shape" className={css.homeImage} />
          </div>
          <div className={css.addressText}>
            <h2 className={css.addressHeading}>
              {orderInfo.address.addressSubType === 'DELIVERY' && (
                <FormattedMessage id="orderdetails_deliverto" defaultMessage="Deliver to " />
              )}
              {orderInfo.address.addressSubType === 'STORE' && (
                <FormattedMessage id="PICKUP" defaultMessage="PICKUP " />
              )}
              {orderInfo.address.addressSubType === 'CARHOP' && (
                <FormattedMessage id="CARHOP" defaultMessage="Carhop " />
              )}
              {orderInfo.address.addressSubType === 'DRIVETHRU' && (
                <FormattedMessage id="DRIVETHRU" defaultMessage="DRIVE THRU" />
              )}
              {orderInfo.address.addressSubType === 'DINEIN' && (
                <FormattedMessage id="DINEIN" defaultMessage="DINE IN " />
              )}
              -
              <>
                {' '}
                {orderInfo.address.addressSubType !== 'DELIVERY'
                  ? selectedStore && selectedStore[storeNameTitle]
                  : orderInfo.address.tag}
              </>
            </h2>
            <p className={css.addressSubheading}>
              {orderInfo.address.addressSubType !== 'DELIVERY'
                ? selectedStore?.[addressString] || ''
                : `${orderInfo.address.bldgName}, ${orderInfo.address.flatNum}, ${orderInfo.address.description}`}
            </p>
          </div>
        </div>
      </div>
    );
  };

  function renderEditDesc(desc, index, currentItem, subItemCount = 0) {
    const hasSubtitle = desc?.subtitle && desc.subtitle.trim() !== '';
    const hasTitle = desc?.title !== itemDetails?.name ? desc?.title : false;
    const hasAdded = desc?.added && desc.added.trim() !== '';
    const hasRemoved = desc?.removed && desc.removed.trim() !== '';
    const hasPrice = desc?.price && parseFloat(desc.price) > 0 ? true : false;
    const isBogo = currentItem?.isBogo ? true : false;
    console.log(desc, 'descdesc111');
    return (
      <div key={index} className={classNames(css.itemwrap, { [css.itemwrapBogo]: isBogo })}>
        {currentItem && (
          <>
            <span className={css.number}>{subItemCount}.</span>
            <span className={css.title}>{currentItem?.name}</span>
            {isBogo && (
              <div className={classNames(css.priceVal, { [css.strikPrice]: subItemCount === 2 })}>
                {decimalChecker(desc.defaultPrice)} {countryValidations?.currency}
              </div>
            )}
          </>
        )}
        <div className={css.titleWrapper}>
          {index > 0 && <span>{!!hasTitle && <span className={css.number}>{index}.</span>}</span>}
          <div className={css.wrapper}>
            {index > 0 && !!hasTitle && (
              <div className={css.priceWrapperItem}>
                <div className={classNames(css.titleCss, { [css.bgSub]: !!currentItem })}>
                  {hasTitle}
                </div>
                {desc?.price > 0 && desc?.addons ? (
                  <div className={css.price}>
                    + {decimalChecker(desc?.price)} {countryValidations?.currency}
                  </div>
                ) : (
                  ''
                )}
              </div>
            )}
            {!!hasSubtitle && (
              <div className={classNames(css.subtitle, { [css.bgSub]: !!currentItem })}>
                {desc.subtitle}
              </div>
            )}
          </div>
        </div>
        {/* Description text */}
        {(!hasSubtitle || !hasTitle) && (
          <>{currentItem ? null : <div className={css.description}>{desc?.description}</div>}</>
        )}
        {hasAdded && (
          <div className={css.added}>
            <div>
              <span className={css.greenColor}>
                <FormattedMessage id={'added'} defaultMessage="Added" />
              </span>
              - <span className={css.custDescp}>{desc.added}</span>
            </div>
            <div>
              {hasPrice && (
                <div className={css.price}>
                  + {decimalChecker(desc.price)} {countryValidations?.currency}
                </div>
              )}
            </div>
          </div>
        )}

        {hasRemoved && (
          <div className={css.added}>
            <div>
              <span className={css.redText}>
                <FormattedMessage id={'removed'} defaultMessage="Removed" />
              </span>
              - <span className={css.custDescp}>{desc?.removed}</span>
            </div>
          </div>
        )}

        {!hasTitle ? null : <hr className={css.dottedline} />}
      </div>
    );
  }

  const renderViewCartContent = () => (
    <>
      <div className={css.detailsContainer}>
        <div className={css.mainDetailWrap}>
          <BackButton handleBack={() => setOpenViewDetailsPopUp((pre) => !pre)} />
          <div className={css.mainHeading}>
            <>
              <div className={css.viewDetails}>{itemDetails?.name}</div>
              <span className={css.priceDetail}>
                {decimalChecker(itemDetails?.price)} {countryValidations?.currency}
              </span>
            </>
          </div>
        </div>

        {(itemDetails?.typeId === 'bundle' ||
          itemDetails?.typeId === 'configurable' ||
          (itemDetails?.typeId === 'simple' && itemDetails?.editDesc.length)) &&
          itemDetails?.editDesc.map((desc, index) => {
            return renderEditDesc(desc, index);
          })}
        {itemDetails?.subItem?.map((item, subIndex) => (
          <div key={subIndex} className={css.subItemWrap}>
            {(item?.editDesc || []).map((desc, editDescIndex) => (
              <div key={editDescIndex} className={css.subItemEditDesc}>
                {renderEditDesc(desc, editDescIndex, item, subIndex + 1)}
              </div>
            ))}
          </div>
        ))}
      </div>
    </>
  );

  //VIEW MORE INFO
  const handleClick = (event, item) => {
    event.preventDefault();
    setOpenViewDetailsPopUp((prev) => !prev);
    setItemDetails((pre) => item);
  };

  // CARD FOR ORDER ITEMS
  const OrderCards = () => {
    return (
      <>
        <span className={css.items}>
          {orderInfo.items.length}
          &nbsp;
          {orderInfo?.items?.length > 1 ? (
            <FormattedMessage id="checkout_items" defaultMessage="Items" />
          ) : (
            <FormattedMessage id="checkout_item" defaultMessage="Item" />
          )}
        </span>
        <div className={css.orderCardContainer}>
          {orderInfo.items.map((item, i) => (
            <div className={css.card} key={i}>
              <div className={css.column1}>
                <img
                  src={`${item?.assets?.[0].src}`}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = noImg;
                  }}
                  alt="Item"
                  className={css.image}
                />
              </div>
              <div className={css.column2}>
                <h2 className={css.mealHeading}>{item.name}</h2>
                <a href="#" onClick={(e) => handleClick(e, item)} className={css.detailsLink}>
                  <FormattedMessage id={'view_details'} defaultMessage={'View Details'} />
                  <FaAngleDoubleDown className={css.arrow} />
                </a>
              </div>
              <div className={css.column3}>
                <h2 className={css.mealHeading}>
                  {' '}
                  {orderInfo?.promo?.freeItems?.indexOf(item.sku) > -1 || item?.price === 0 ? (
                    <>
                      {orderInfo?.promo?.couponType === 'discountItem' ? (
                        <>
                          {decimalChecker(item.sellingPrice - orderInfo?.promo?.maxDiscountAmt)}{' '}
                          {countryValidations?.currency}
                        </>
                      ) : (
                        <FormattedMessage id="free" defaultMessage="free" />
                      )}
                    </>
                  ) : (
                    <>
                      {decimalChecker(item.price)} {countryValidations?.currency}
                    </>
                  )}
                </h2>
                <p className={css.qty}>
                  <FormattedMessage id="oderdetails_qty" defaultMessage="QTY" />:{item.qty}
                </p>
              </div>
            </div>
          ))}
        </div>
      </>
    );
  };

  return (
    <div className={css.root}>
      {!isDesktop ? (
        <Header
          title={<FormattedMessage id="order_detail" defaultMessage="Order Details" />}
          actionButtons={[<LanguageButton />]}
        />
      ) : (
        <div className={css.header}>
          <div className={css.headerBackArrow}>
            <div className={css.iconSection}>{backIcon}</div>
            <div className={css.mainHeading}>
              <FormattedMessage id="order_detail" defaultMessage="Order Details" />
            </div>
          </div>
        </div>
      )}
      <main className={css.main}>
        <Grid>
          <Paper>
            <Grid className={css.orderInfo}>
              <Card />
              <CardAddress />
              <OrderCards />
            </Grid>
          </Paper>
        </Grid>
        {isDesktop ? (
          <DialogBox
            size="md"
            hideCloseButton
            leftAlign
            className={css.viewDetailsDialog}
            isOpen={openViewDetailsPopup}
          >
            {renderViewCartContent()}
          </DialogBox>
        ) : (
          <DrawerPwa
            variant="temporary"
            anchor="bottom"
            open={openViewDetailsPopup}
            className={css.drawer}
            hideCloseButton={true}
          >
            {renderViewCartContent()}
          </DrawerPwa>
        )}
      </main>
      <footer className={css.footer}></footer>
    </div>
  );
}

export default OrderDetail;
